<template>
  <div class="modal-content fm-modal-upload">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ $t("filemanager.menucontext.modifyDocumentType") }}
      </h5>
      <button type="button" class="close" aria-label="Close" v-on:click="hideModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="fm-upload-list">
        <div class="row">
          <div class="col-md-12">
            <select class="form-control mb-4" @change="setFileDocumentType($event)">
              <option :value="null" selected disabled>
                {{documentTypeName}}
              </option>
              <option v-for="documentType in documentTypes" :key="documentType.id" :value="documentType.id">
                {{ documentType.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn" v-bind:class="[docTypeLoading ? 'btn-primary' : 'btn-light']"
        v-bind:disabled="!docTypeLoading || uploadHasFilesWithoutTypes" v-on:click="modify">
        {{ $t("filemanager.btn.submit") }}
      </button>
      <button class="btn btn-light" v-on:click="hideModal()">
        {{ $t("filemanager.btn.cancel") }}
      </button>
    </div>
  </div>
</template>

<script>
import modal from "../mixins/modal";
import helper from "../../../router/mixins/helper";
import { mapActions, mapState } from "vuex";

export default {
  name: "Upload",
  mixins: [modal, helper],
  data() {
    return {
      newFiles: [],
      overwrite: 0,
      docType: {},
      docTypes: [],
      classification: "overall_classification",
      messageError: null,
      docTypeLoading: false,
      docTypeId: null,
      documentTypeName: null
    };
  },
  watch: {
    classification() {
      this.resetFilesTypes();
    },
  },
  computed: {
    /**
     * Progress bar value - %
     * @returns {number}
     */
    progressBar() {
      return this.$store.state.messages.actionProgress;
    },

    /**
     * Count of files selected for upload
     * @returns {number}
     */
    countFiles() {
      return this.newFiles.length;
    },

    uploadHasFilesWithoutTypes() {
      return this.newFiles.some((e) => e.type === null);
    },

    /**
     * Calculate the size of all files
     * @returns {*|string}
     */
    allFilesSize() {
      let size = 0;

      for (let i = 0; i < this.newFiles.length; i += 1) {
        size += this.newFiles[i].file.size;
      }

      return this.bytesToHuman(size);
    },
    document() {
      return this.$store.getters["selectedItems"][0];
    },
    ...mapState({
      documentTypes: (state) => state.documentType.documentTypes,
    }),
  },
  methods: {
    ...mapActions(["getDocumentTypes", "getDocumentTypeMetadas"]),
    resetFilesTypes() {
      this.newFiles = this.newFiles.map((e) => {
        return { file: e.file, type: null };
      });
    },

    setFileDocumentType(event) {
      this.docTypeId = parseInt(event.target.value);
      this.docTypeLoading = true;
    },
    /**
     * modify type of document
     */
    modify() {
      const data = {
        document_id: this.document.doc_id,
        docType_id: this.docTypeId,
      };
      this.$store.dispatch("modifyDocumentType", data).then((response) => {
        if (response.status === 200) {
          this.$store.dispatch('refreshManagers');
          this.hideModal();
        }
      });
    },
  },
  created() {
    this.getDocumentTypes()
      .then((response) => {
        if (response.status == 200) {
          this.isLoading = false;
          this.documentType = response.data;
        } else {
          this.isLoading = false;
        }
      })
      .catch(() => {
        this.isLoading = false;
      });

      this.getDocumentTypeMetadas(this.document.type_id).then((response) => {
        this.documentTypeName = response.data.DocumentType.name;
      });
  },
};
</script>

<style lang="scss">
.fm-modal-upload {
  .fm-btn-wrapper {
    position: relative;
    overflow: hidden;
    padding-bottom: 6px;
    margin-bottom: 0.6rem;
  }

  .fm-btn-wrapper input[type="file"] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }

  .fm-upload-list .far {
    padding-right: 0.5rem;
  }

  .fm-upload-list .form-check-inline {
    margin-right: 0;
  }

  .fm-upload-info>.progress {
    margin-bottom: 1rem;
  }
}
</style>
